import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=12a4e95e&"
import script from "./Cashback.vue?vue&type=script&lang=js&"
export * from "./Cashback.vue?vue&type=script&lang=js&"
import style0 from "./Cashback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports